<template>
  <div>
    <custom-actions>
      <template #header>
        <el-button type="primary" @click="showForm(null)">新增账号</el-button>
      </template>
      <el-form :model="searchForm" ref="formData" inline class="global-form-label-width account-form"
        label-width="100px">
        <el-form-item label="名称" prop='userName'>
          <el-input clearable v-model="searchForm.userName" placeholder="名称" />
        </el-form-item>
        <el-form-item label="角色" prop="roleId">
          <el-select v-model="searchForm.roleId" filterable clearable>
            <el-option :label="item.roleName" :value="item.roleId" v-for="(item, index) of roles"
              :key="index"></el-option>
          </el-select>
        </el-form-item>
        <!-- <el-form-item v-if="activeType === '1'" label="所属部门" prop="deptId">
          <el-cascader
            ref="cascader"
            :options="deptData"
            placeholder="请选择所属部门"
            :show-all-levels="false"
            @change="closeCascader"
            clearable
            v-model="searchForm.deptId"
            :props="{
              emitPath: false,
              label: 'deptName',
              value: 'deptId',
              children: 'childNode',
              checkStrictly: true
            }"
          ></el-cascader>
        </el-form-item> -->
        <el-form-item label="手机号" prop="mobile">
          <el-input clearable v-model="searchForm.mobile" placeholder="手机号" />
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="onSearch">查询</el-button>
          <el-button @click="onReset">重置</el-button>
        </el-form-item>
      </el-form>
    </custom-actions>

    <el-card shadow="never" class="mt10">
      <div class="wrap">

        <div class="left-tree">
          <div class="title">部门名称</div>
          <el-tree :data="treeData" :props="defaultProps" @node-click="handleNodeClick"></el-tree>
        </div>
        <div class="right-table">
          <el-table size="mini" stripe border v-loading="loading" :data="tableData"
             style="width:100%">
            <el-table-column  min-width="120" label="部门名称" prop="deptName"></el-table-column>
            <el-table-column min-width="100" label="名称" prop="userName"></el-table-column>
            <!-- 经手人编码与账号管理表单共用 userNo 字段。 -->
            <el-table-column min-width="120" label="经手人编码" prop="userNo"></el-table-column>
            <el-table-column min-width="110" label="登录账号" prop="loginId"></el-table-column>
            <el-table-column min-width="110" label="手机号" prop="mobile"></el-table-column>
            <!-- <el-table-column label="用户类型" prop="userTypeName"></el-table-column> -->
            <el-table-column min-width="110" label="角色名称" prop="roleName"></el-table-column>
            <!-- <el-table-column min-width="160" label="部门名称" prop="deptName"></el-table-column> -->
            <el-table-column min-width="140" label="是否部门负责人" prop="isLeader">
              <template v-slot="{ row }">
                <el-tag :type="row.isLeader === '1' ? 'success' : 'danger'">{{ row.isLeader === '1' ? '是' : '否'
                  }}</el-tag>
              </template>
            </el-table-column>
            <!-- <el-table-column width="120" label="证件类型" prop="idCardTypeNumName"></el-table-column>
        <el-table-column width="120" label="证件号码" prop="idCard"></el-table-column>
        <el-table-column width="120" label="出生日期" prop="birthday"></el-table-column>
        <el-table-column width="150" label="健康证有效日期" prop="healthyEndDate"></el-table-column> -->
            <el-table-column width="250" label="操作" fixed="right">
              <template v-slot="{ row }">
                <template v-if="row.isAdmin === '0'">
                  <el-button type="text"
                    @click="$router.push('/system/account/edit?userId=' + row.userId)">编辑</el-button>
                  <el-button type="text" @click="resetPassword(row.userId)">重置密码</el-button>
                  <el-button type="text" v-if="row.userId !== '2021020603'" @click="deleteRow(row.userId)"
                    class="del-btn">删除</el-button>
                </template>
              </template>
            </el-table-column>
          </el-table>

          <el-pagination class="mt15" :current-page.sync="page" background layout="total, prev, pager, next"
            :total="total" @current-change="loadData">
          </el-pagination>
        </div>
      </div>

    </el-card>

  </div>
</template>

<script>
import keepAlive from '@/mixins/keepAlive'

export default {
  name: 'AccountManage',
  mixins: [keepAlive],
  data () {
    return {
      activeType: '1',
      tableData: [],
      roles: [],
      page: 1,
      total: 0,
      loading: false,
      searchForm: {
        userName: null,
        mobile: '',
        roleId: '',
        deptId: ''
      },
      treeData: [],
      defaultProps: {
        children: 'childNode',
        label: 'deptName',
        value: 'deptId'
      },
      dialogVisible: false,
      currentDeptId: ''
    }
  },
  created () {
    this.loadTree()
    this.loadData()
    this.loadRoles()
  },
  computed: {
    deptData () {
      return this.$store.state.deptList
    }
  },
  methods: {
    loadTree() {
      this.$axios.get(this.$apis.system.selectSysDeptByList).then(res => {
        this.treeData = res
      })
    },
    handleNodeClick(data, node) {
      console.log('node: ', node.level)
      console.log('data: ', data)
      this.currentDeptId = data.deptId

      if (node.level === 1) {
        this.currentDeptId = ''
      }
      this.page = 1
      this.loadData()
    },
    loadRoles () {
      this.$axios.get(this.$apis.system.selectSysRoleByList).then(res => {
        this.roles = res
      })
    },
    closeCascader () {
      this.$refs.cascader.dropDownVisible = false
    },
    loadData () {
      const params = {
        page: this.page,
        userType: '1',
        mobile: this.searchForm.mobile,
        userName: this.searchForm.userName,
        roleId: this.searchForm.roleId,
        deptId: this.currentDeptId
      }
      this.$axios.get(this.$apis.system.selectSysUserByPage, {
        params: params
      }).then(res => {
        this.tableData = res.list
        this.total = res.total
      })
    },
    onSearch () {
      this.page = 1
      this.loadData()
    },
    onReset () {
      this.$refs.formData.resetFields()
    },
    showForm () {
      this.$router.push('/system/account/add')
    },
    resetPassword (userId) {
      this.$confirm('重置后的密码为用户手机号后六位, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.$axios.post(this.$apis.system.resetPassword, {
          userId
        }).then(() => {
          this.loadData()
        })
      })
    },
    deleteRow (userId) {
      this.$confirm('确认删除该记录, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.$axios.post(this.$apis.system.deleteSysUser, {
          userId
        }).then(() => {
          this.loadData()
        })
      })
    }
  }
}
</script>

<style scoped lang='scss'>
.account-form {

  .el-select,
  .el-input,
  .el-cascader {
    width: 200px !important;
  }
}

.wrap{
  display: flex;
  .left-tree{
    width:320px;
    flex-shrink: 0;
    .title{
      background-color: #ecf1ff;
      width: 100%;
      height:34px;
      display: flex;
      align-items: center;
      padding: 0 14px;
    }
    ::v-deep .el-tree{
      .el-tree-node{
        margin:8px 0;
      }
      .el-tree-node__label{
        max-width: 280px;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
      }
    }
  }
  .right-table{
    flex: 1;
    margin-left: 10px;
    width: 100%;
    overflow: auto;
  }

}
</style>
